import { Component, OnInit } from '@angular/core';
import { AirportRunways } from 'src/app/model/airportRunways';
import { AirportRunwayNumbers } from 'src/app/model/airportRunwayNumbers';
import { CurrentAptService } from 'src/app/service/current-apt.service';
import { CurrentRwyService } from 'src/app/service/current-rwy.service';
import { AirportRunwaysService } from '../../service/airport-runways.service';
import { AirportRunwayNumbersService } from '../../service/airport-runway-numbers.service';
import { ApiRequest, Filter, FilterComposit, FilterPredicate, Sort, SortCondition, PageInfo, ApiResponse } from '../../model/api-request';

@Component({
  selector: 'app-airport-runway',
  templateUrl: './airport-runway.component.html',
  styleUrls: ['./airport-runway.component.css']
})
export class AirportRunwayComponent implements OnInit {
  public apiRequest: ApiRequest;
  public apiRequestRwy: ApiRequest;
  public apiResponse: ApiResponse;
  public currentAirport: string;
  public currentRunway: string;
  public airportRunway: AirportRunways[];
  public airportRunwayNumbers: AirportRunwayNumbers[];
  public initialRwySelected: boolean[] =[true, false];

  constructor(private data: CurrentAptService,private rwy: CurrentRwyService,
    private airportRunwaysService: AirportRunwaysService,
    private airportRunwayNumber: AirportRunwayNumbersService) { }

  ngOnInit() {

    this.data.currentAirport.subscribe(currentLocid => this.currentAirport = currentLocid);

    this.apiRequest = new ApiRequest();

    let filterPredicate1: Array<FilterPredicate>;
    let filterCompositArray: Array<FilterComposit>;
    let sortConditionArray: Array<SortCondition>;

    this.apiRequestRwy = new ApiRequest();

    let filterPredicateRwy1: Array<FilterPredicate>;
    let filterPredicateRwy2: Array<FilterPredicate>;
    let filterCompositArrayRwy: Array<FilterComposit>;
    let sortConditionArrayRwy: Array<SortCondition>;

    filterPredicate1 = [new FilterPredicate('AirportIdentifier', 'String', this.currentAirport, 'IsEqualTo')];
    filterCompositArray = [new FilterComposit(filterPredicate1, 'Or')];
    this.apiRequest.filter = new Filter(filterCompositArray, 'And');

    sortConditionArray = [new SortCondition('RwyIdentifier', 'Ascending')];
    this.apiRequest.sort = new Sort(sortConditionArray);

    this.apiRequest.pageInfo =new PageInfo(0, 1, 5);

    this.airportRunwayNumber.getMultiple(this.apiRequest).subscribe((result => {
      this.airportRunwayNumbers = result.data as AirportRunwayNumbers[];

      this.rwy.setCurrentRunway(this.airportRunwayNumbers[0].rwyIdentifier);
      this.rwy.currentRunway.subscribe(currentRwyIdentifier => this.currentRunway = currentRwyIdentifier);


      filterPredicateRwy1 = [new FilterPredicate('AirportIdentifier', 'String', this.currentAirport,'IsEqualTo')];
      filterPredicateRwy2 = [new FilterPredicate('RwyIdentifier','String',this.currentRunway,'IsEqualTo')];
      filterCompositArrayRwy = [new FilterComposit(filterPredicateRwy1, 'Or'), new FilterComposit(filterPredicateRwy2, 'Or')];
      this.apiRequestRwy.filter = new Filter(filterCompositArrayRwy, 'And');


      sortConditionArrayRwy = [new SortCondition('ID', 'Ascending')];
      this.apiRequestRwy.sort =new Sort(sortConditionArrayRwy);

      this.apiRequestRwy.pageInfo = new PageInfo(0, 1, 5);

      this.airportRunwaysService.getMultiple(this.apiRequestRwy).subscribe((result => {
      this.airportRunway = result.data as AirportRunways[];


      }));

    }));





  }
  onairportRwy(airportRwyparameterpassed: string){


    this.rwy.setCurrentRunway(airportRwyparameterpassed);
    this.rwy.currentRunway.subscribe(currentRwyIdentifier => this.currentRunway = currentRwyIdentifier);
    this.apiRequestRwy = new ApiRequest();

    let filterPredicateRwy1: Array<FilterPredicate>;
    let filterPredicateRwy2: Array<FilterPredicate>;
    let filterCompositArrayRwy: Array<FilterComposit>;
    let sortConditionArrayRwy: Array<SortCondition>;


    filterPredicateRwy1 = [new FilterPredicate('AirportIdentifier', 'String', this.currentAirport,'IsEqualTo')];
    filterPredicateRwy2 = [new FilterPredicate('RwyIdentifier', 'String', this.currentRunway, 'IsEqualTo')];
    filterCompositArrayRwy = [new FilterComposit(filterPredicateRwy1, 'Or'), new FilterComposit(filterPredicateRwy2, 'Or')];
    this.apiRequestRwy.filter = new Filter(filterCompositArrayRwy, 'And');


    sortConditionArrayRwy = [new SortCondition('ID', 'Ascending')];
    this.apiRequestRwy.sort = new Sort(sortConditionArrayRwy);

    this.apiRequestRwy.pageInfo = new PageInfo(0, 1, 5);

    this.airportRunwaysService.getMultiple(this.apiRequestRwy).subscribe((result => {
    this.airportRunway = result.data as AirportRunways[];

    }));
  }
}
